import { Boolean, InstanceOf, Partial, Record, String } from "runtypes";
import { SubmissionCoordinates } from "./coordinates";
import { Deadline } from "./deadline";
export const Submission = SubmissionCoordinates.And(
  Record({
    contents: String
  })
).And(
  Partial({
    version: String,
    contentHash: String,
    originalID: String
  })
);
export const SavedSubmission = SubmissionCoordinates.And(
  Record({
    submission: Submission,
    submissionHash: String,
    id: String,
    timestamp: InstanceOf(Date),
    started: InstanceOf(Date),
    counted: Boolean,
    browserID: String
  })
).And(
  Partial({
    number: String,
    semester: String,
    email: String,
    deadline: Deadline
  })
);
//# sourceMappingURL=submission.js.map
